<!-- 
 01-01-2025
 Copyright (c) 2016 Aruba. All Rights Reserved.  
 -->
<div class="modal-header">
    <div class="modal-title h4">{{'accountSecurity.twoFactorAuth.bannerPwd.bannerTitle' | translate}}</div>

    <button aria-label="Close" data-dismiss="modal" class="close" type="button" (click)="activeModal.close()">
        <span aria-hidden="true">{{'main.charX' | translate}}</span>
    </button>
</div>
<div class="modal-body">
    <div class="row">
        <div class="col-12">
            <div class="row g-0 warning-bg py-3 mb-3">
                <div class="col-2 col-sm-1 text-center ps-3">
                    <svg-icon src="content/images/icons/alert-triangle.svg" 
                      [svgStyle]="{ 'width.px':'22', 'height.px':'22', 'vertical-align': 'top' }">
                    </svg-icon>
                </div>
                <div class="col-10 col-sm-11 text-start ps-3 pe-2">
                   <b> 
                    <span 
                      [innerHTML]="'accountSecurity.twoFactorAuth.bannerPwd.bannertitleban' 
                      | translate : {expireDate: expireDate }">
                    </span>
                   </b>
                </div>
            </div>
        </div>
        <div class="col-12">
            <p [innerHTML]="'accountSecurity.twoFactorAuth.bannerPwd.genBannerMessage' | translate"></p>
        </div>
    </div>
</div>
<div class="modal-footer justify-content-start">
        <button class="btn btn-primary p-0" (click)="goProgramPassword()"> 
            {{'accountSecurity.twoFactorAuth.bannerPwd.genBannerBtn' | translate}}</button>
    <button class="btn btn-link pl-2" (click)="cancelAction()">
        {{'accountSecurity.twoFactorAuth.bannerPwd.btnClose' | translate}}</button>
</div>
